module.exports = __webpack_public_path__ + "img/banner-left-1920.117fb7f1.png";